import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/move';

/** 状況 `move_destroy`（組み立ては `../fx/move.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'move_destroy', role: 'effect', ...spec }, 'move_destroy_effect.js');
